'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RelatedArticlesCarousel = function RelatedArticlesCarousel(el) {
  (0, _classCallCheck3.default)(this, RelatedArticlesCarousel);

  new _flickity2.default((0, _functional.getElement)('[data-module="carousel"]'), {
    cellAlign: 'left',
    wrapAround: true,
    pageDots: false
  });
};

exports.default = RelatedArticlesCarousel;